<template>
    <div>
    <div class="pagina page-index d-flex flex-column justify-content-between">
        <header>
            <div class="container-fluid">
                <div class="brand-logos">
                    <a class="navbar-brand">
                        <img :src="require('@/assets/css/img/logo-fs.png')" class="logo-fs" alt="logo Fondos Sociales" />
                    </a>
                    <a class="navbar-brand">
                        <img :src="require('@/assets/css/img/logo-telefonica.png')" class="logo-tlf" alt="logo Telefonica" />
                    </a>
                </div>
            </div>
        </header>

        <main>
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 d-flex flex-column justify-content-center mb-2">
                        <h1 class="h1-index">Programa de Vacaciones * </h1>
                        <span class="year">{{ ano }}</span>
                    </div>
                    <div class="col-lg-4">
                        <div class="card-login p-5">
                            <h3 class="mb-3">Acceso empleados</h3>

                            <!-- <a href="AppLlamadas:307198&telefono=666555444">**Llamadas</a>
                            <a href="CalCuLa://123 456 789">**Calcula</a> -->

                            <b-form>
                                <b-form-group class="pt-2"
                                    label="Usuario" label-for="user"
                                    v-bind="attr_user">
                                    <b-input-group class="my-2">
                                        <b-form-input type="text" id="user" ref="user"
                                            v-model="user.user" trim
                                            v-bind="attr_user">
                                        </b-form-input>
                                        <!-- <b-input-group-prepend is-text><b-icon-person-fill/></b-input-group-prepend>                    -->
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group
                                    label="Contraseña / Password" label-for="pass">
                                    <b-input-group class="my-2">
                                        <b-form-input id="pass" ref="pass" minlength="6" maxlength="24"
                                            v-bind:type="showPass?'text':'password'"
                                            v-model="user.pass"
                                            v-bind="attr_pass"
                                            @keypress.13="check">
                                        </b-form-input>
                                        <b-input-group-prepend is-text @click="showPass=!showPass" class="light">
                                            <b-icon variant="success" :icon="!showPass ?'eye':'eye-slash-fill'"/>
                                        </b-input-group-prepend>
                                    </b-input-group>
                                </b-form-group>

                                <div class="text-center">
                                    <p class="mt-3">
                                        <!-- <b-btn size="sm">Restablecer Contraseña</b-btn> -->
                                        <b><a href="#" class="mr-2 text-white" @click="restablecer">Restablecer / Activar Contraseña</a></b>
                                    </p>
                                    <b-button variant="primary" size="sm" @click.prevent="check">
                                        Acceder
                                    </b-button>
                                </div>
                            </b-form>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <footer>
            <div class="container-fluid legal-info">
                <div class="container">
                    <div class="row">
                        <div class="col d-flex pt-3 pb-3">
                            <div>Fondos Sociales - Telefónica</div>
                            <!-- <div class="ml-auto">
                                <a href="/condiciones-generales.html">Condiciones Generales</a>
                                <a href="/politica-privacidad.html">Politica de Privacidad</a>
                                <a href="/aviso-legal.html">Aviso Legal</a>
                                <a href="#" data-toggle="modal" data-target="#contactForm">Contacto</a>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>

    <!-- Modal Login Response -->
    <!-- <div class="modal fade" id="response" tabindex="-1" role="dialog" aria-labelledby="loginFormTitle"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="form">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="loginFormTitle">Información</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <img src="img/logo-fs.png" alt="">
                    <p class="m-3">El <strong>Programa de Vacaciones 2021</strong>
                        aún no está disponible. Por favor, vuelve a visitarnos un poco más adelante.
                    </p>

                </div>
            </div>
        </div>
    </div> -->
</div>


</template>

<script>

//import login from '@/components/login.vue'
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'home',
  components: { //login,
  },
  data() {
    return {
        ano: '2022',

        user: { user:'', pass:'', error: '', logU: false, logP: false, sid: '' },
        error: { error: false, msg: '', title:'' },

        showPass: false
    }
  },

  created() {

    if (this.logueado) {
      if (this.$route.name=='home')
        this.$router.push('/entrada');
      else
        this.$bvModal.hide("modal_login");
    }

    // año actual
    this.ano=new Date().getFullYear();
  },

  computed: {
    ...mapState(['auth','errores']),

    logueado() {
      return this.auth.logueado;
    },
    lopd() {
      return this.auth.lopd;
    },
    usuario() {
        return this.$store.state.auth.user;
    },

    // atributos usuario / acceso
    attr_user() {
      //if (this.user.logU) return {state: true, disabled: false, "valid-feedback": "USUARIO REGISTRADO" };
      //if (this.user.error) return {state: false, disabled: false, "invalid-feedback": this.user.error };
      return { disabled: false};
    },
    attr_pass() {
      return { disabled: false};
    },
    // texto boton
    btn_login() {
      return "ACCEDER"; //(!this.user.logU ? "CONTINUAR" : "CONECTARSE");
    }

  },

  methods: {
    ...mapMutations(['loading','alerta','modal']),
    ...mapActions(['exec']),

    check() {
        let u=this.user.user;
        let p=this.user.pass;
        let t=this.auth.token;

        //if (u==='') { this.user.error="Debes Introducir un Usuario"; return; }
        //if (p==='') { this.user.error="Debes Introducir una Contraseña"; return; }
        if (u=='') { this.modal({tit:"Login / Acceso", msg: "Debes Introducir un Usuario"}); return; }
        if (p=='') { this.modal({tit:"Login / Acceso", msg: "Debes Introducir una Contraseña"}); return; }

        let args={user: u, token: t, pass:p};
        this.login(args);
    },

    async login(args) {
        let r=await this.exec({api:'login0', arg:args});
        this.login_back(r);
    },

    login_back(r) {
      this.user.error="";
      //////////////////////////////////////////////si error
        if (r.error) {
            this.restablecer_back(r.datos);
            this.user.error=r.datos;
            //this.modal({tit:"Login / Acceso", msg: this.user.error});
            this.$refs.pass.focus();
            return;
        }

        this.$store.commit('login_back',r);
        this.$router.push('/inicio');

        //modal lopd
        this.acepta_lopd();
    },

    acepta_lopd() {
        this.$bvModal.show("modal_lopd");  console.log('loginnnnn',this.lopd);
        return this.lopd;
    },

    async restablecer() {
        let u=this.user.user;
        if (u=='') { this.modal({tit:"Login / Acceso", msg: 'Debes introducir el dato de Usuario para proceder.'}); return; }
        //alert('Olvidar Contraseña');

        /* //comprobamos sistema abierto
        let r=await this.exec({api:'cerrado', arg:{fnt: 'restablecer' }});
        if (r) { this.restablecer_back('cer'); return; }               */

        //let r=await this.exec({api:'restablecer', arg:{fnt: 'set', user: u }});

        let msg="Estas Seguro RESTABLECER / ACTIVAR Contraseña ? <br>Usuario: <b>" + u + "</b><br><br>Se procederá al envio de un correo electrónico.";
        let r=await this.$root.$msgConf(msg, 'Login/Acceso');
        if (!r) return;

        //this.loading();
        r=await this.exec({api:'restablecer', arg:{fnt: 'set', user: u }});
        this.restablecer_back(r.datos);

        this.$refs.user.focus();
    },

    restablecer_back(r='') {
        let m1="<small>Debes de contactar con nosotros en el Teléfono <br><b>900 35 10 10</b>.</small>";
        let m2="<small>Para cualquier duda o consulta puedes contactar con nosotros en el Teléfono <br><b>900 35 10 10</b>.</small>";
        //this.modal({tit:"Login/Acceso", msg: m});

        //if (r.error) {
            let m=r;
            if (m=='cer')  m="Sistema Cerrado por Administración.<br><br>" + m2; else
            if (m=='usu')  m="Datos de Usuario incorrectos. Inténtelo de nuevo.<br><br>" + m2; else
            if (m=='tfn')  m="No disponemos de su correo electrónico para iniciar el procedimiento para restablecer su contraseña para acceder a la web.<br><br>" + m1; else
            if (m=='pas')  m="Datos de Acceso erroneos. Inténtelo de nuevo.<br>"; else
            if (m=='pas1') m="Su contraseña no cumple los criterios de seguridad: entre 6 y 15 caracteres, al menos una letra y ún número.<br>"; else
            if (m=='pas2') m="Su contraseña no cumple los criterios de seguridad: entre 6 y 15 caracteres, al menos una letra y ún número.<br>"; else
            if (m=='pas3') m="Su contraseña no cumple los criterios de seguridad: No puede ser la misma o estar contenida de las tres últimas utilizadas.<br>"; else
            if (m=='cad')  m="Su contraseña ha caducado o no ha sido inicializada esta temporada.<br>Deberá pulsar Restablecer Contraseña y seguir el procedimiento que se le indica.<br>"; else
            if (m=='ema')  m="Se ha procedido al envio de un email a su direccion de correo con un enlace para restablecer/activar su cuenta de acceso a la web. Siga las indicaciones del mismo.<br><br>" + m2; else
            m="Error - En estos momentos imposible procedimiento.<br><br><b>" + m +"</b><br><br>"+m2;

            //m="Su contraseña ha caducado o no ha sido inicializada esta temporada.<br>Deberá pulsar Restablecer Contraseña y seguir el procedimiento que se le indica.<br>";

            this.modal({tit:"Login / Acceso", msg: m, time:0});
            //return;
        //}
    },

  },

}
</script>
